import React from "react";
import styles from "styles/logoutCard.module.scss";
import { useKeycloak } from "@react-keycloak/web";
import logoutVectorIcon from "../img/genai/Vector.svg";

const LogoutDropdownCard = (props) => {
  const { getFirstLetters, getUserNameEmail } = props;
  const { keycloak } = useKeycloak();
  const userLogout = () => {
    keycloak.logout({ redirectUri: "https://contentstudio.gilead.com" });
    localStorage.removeItem("notificationDismissed_1");
    localStorage.removeItem("notificationDismissed_0");
  };
  return (
    <div className={styles.logoutCard}>
      <div className={styles.userInfoSection}>
        <div className={styles.userNameOuterLine}>
          <span className={styles.userName}> {getFirstLetters()}</span>
        </div>
        <div className={styles.userDetails}>
          <div className={styles.logoutCardName}>
            {getUserNameEmail?.userInfo?.name || ""}
          </div>
          <div className={styles.logoutCardEmail}>
            {getUserNameEmail?.userInfo?.email || ""}
          </div>
        </div>
      </div>
      <div className={styles.separator}></div>
      <div className={styles.logoutButtonContainer}>
        <button
          className={`btn btn-link ${styles.logoutBtn}`}
          type="button"
          onClick={userLogout}
        >
          <img
            src={logoutVectorIcon}
            alt="Logout"
            className={styles.logoutIcon}
          />
          <span>Log Out</span>
        </button>
      </div>
    </div>
  );
};
export default LogoutDropdownCard;
